/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Invite_Email_RequiredInputs */

const en_team_invite_email_required = /** @type {(inputs: Team_Invite_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please enter an email address.`)
};

const es_team_invite_email_required = /** @type {(inputs: Team_Invite_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por favor, introduce un correo.`)
};

const fr_team_invite_email_required = /** @type {(inputs: Team_Invite_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veuillez entrer une adresse e-mail.`)
};

const de_team_invite_email_required = /** @type {(inputs: Team_Invite_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte gib eine E-Mail-Adresse ein.`)
};

const id_team_invite_email_required = /** @type {(inputs: Team_Invite_Email_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Harap masukkan alamat email.`)
};

/** @type {(inputs: Team_Invite_Email_RequiredInputs) => LocalizedString} */
const ja_team_invite_email_required = en_team_invite_email_required;

/** @type {(inputs: Team_Invite_Email_RequiredInputs) => LocalizedString} */
const zh_team_invite_email_required = en_team_invite_email_required;

/** @type {(inputs: Team_Invite_Email_RequiredInputs) => LocalizedString} */
const ar_team_invite_email_required = en_team_invite_email_required;

/** @type {(inputs: Team_Invite_Email_RequiredInputs) => LocalizedString} */
const it_team_invite_email_required = en_team_invite_email_required;

/** @type {(inputs: Team_Invite_Email_RequiredInputs) => LocalizedString} */
const ru_team_invite_email_required = en_team_invite_email_required;

/** @type {(inputs: Team_Invite_Email_RequiredInputs) => LocalizedString} */
const pt_team_invite_email_required = en_team_invite_email_required;

/** @type {(inputs: Team_Invite_Email_RequiredInputs) => LocalizedString} */
const ko_team_invite_email_required = en_team_invite_email_required;

/**
* | output |
* | --- |
* | "Please enter an email address." |
*
* @param {Team_Invite_Email_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const team_invite_email_required = /** @type {((inputs?: Team_Invite_Email_RequiredInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Invite_Email_RequiredInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_team_invite_email_required(inputs)
	if (locale === "es") return es_team_invite_email_required(inputs)
	if (locale === "fr") return fr_team_invite_email_required(inputs)
	if (locale === "de") return de_team_invite_email_required(inputs)
	if (locale === "ja") return ja_team_invite_email_required(inputs)
	if (locale === "zh") return zh_team_invite_email_required(inputs)
	if (locale === "ar") return ar_team_invite_email_required(inputs)
	if (locale === "id") return id_team_invite_email_required(inputs)
	if (locale === "it") return it_team_invite_email_required(inputs)
	if (locale === "ru") return ru_team_invite_email_required(inputs)
	if (locale === "pt") return pt_team_invite_email_required(inputs)
	return ko_team_invite_email_required(inputs)
});